import { render, staticRenderFns } from "./TopHeader.vue?vue&type=template&id=455d4a58&scoped=true"
import script from "./TopHeader.vue?vue&type=script&lang=js"
export * from "./TopHeader.vue?vue&type=script&lang=js"
import style0 from "./TopHeader.vue?vue&type=style&index=0&id=455d4a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455d4a58",
  null
  
)

export default component.exports